/**
 * Action type constants for odc.volto.
 * @module constants/ActionTypes
 */

export const GET_SOCIAL_NETWORKS = 'GET_SOCIAL_NETWORKS';
